/* src/app/timeline-transport/partals/timeline-artic-contract-orders/timeline-artic-contract-orders.component.scss */
.header {
  background-color: white;
  color: white;
  padding: 0.5rem;
  padding: 0;
  background: #34495e;
}
.bodyContainer {
  background-color: white;
  height: 95%;
  min-height: 50rem;
}
.acceptedOrdersContainer {
  position: fixed;
  width: 17rem;
  font-size: 0.65rem;
  min-height: 50rem;
  left: 16.2%;
  top: 6.2%;
  z-index: 99;
  border: 3px solid #27ae60;
}
.acceptedOrdersContainer .btn-small {
  width: 2rem;
}
.orderContainer {
  background-color: #bdc3c7;
}
.orderContainer.old {
  background-color: pink;
}
.orderContainer {
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: grab;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
}
.dragging {
  opacity: 0.5;
  transform: scale(0.8);
}
.gridPagination {
  width: 100%;
}
.gridPagination ul {
  display: table;
  margin: 0 auto;
  list-style-type: none;
}
.gridPagination li {
  display: inline-block;
}
.gridPagination li a.active {
  text-decoration: underline;
}
.changed {
  background-color: #c0392b;
  color: white;
}
.clone {
  width: 1rem;
}
/*# sourceMappingURL=timeline-artic-contract-orders.component.css.map */
